/**
 * @generated SignedSource<<3a90643615e98ab2e1349de4e54e3754>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UserConnectionReadView$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly accountId: string;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "UserConnectionReadView";
};
export type UserConnectionReadView$key = {
  readonly " $data"?: UserConnectionReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserConnectionReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "UserConnectionReadView",
  "selections": [
    {
      "concreteType": "JiraUserEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "accountId"
            },
            {
              "kind": "ScalarField",
              "name": "name"
            },
            {
              "kind": "ScalarField",
              "name": "picture"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraUserConnection"
};

(node as any).hash = "cfc79c27bbbda8b9e1a6bde015d76c82";

export default node;
